import SkeletonUI from '@cobliteam/ui/components/Skeleton';

const Skeleton = () => {
  return (
    <SkeletonUI data-testid='filter-skeleton' width={100} height={30}>
      <svg width='100' height='30'>
        <rect x='0' y='0' width='100' height='30' />
      </svg>
    </SkeletonUI>
  );
};

export default Skeleton;
